module.exports = __webpack_public_path__ + "img/pine_amazake.d5f32f86.jpg";